export enum TrailType {
    Unknown = 0,
    UserManagement = 1,
    Rulebook = 2,
    Regulation = 3
}
